<sl-label size="large" i18n>Connect to Dinero</sl-label>
<sl-label color="dark" i18n>This will connect your accounting system with Previsto</sl-label>

<sl-label *ngIf="awaitingPopup" size="small" color="dark" i18n multiline>A popup window or a new tab should have opened now, requesting you to log into Dinero. Please check for any popup-blocker if it doesnt open.</sl-label>
<sl-select class="mt-6" *ngIf="!awaitingPopup" [(ngModel)]="systemId" label="Fiscal" i18n-label>
    <sl-menu-item *ngFor="let entry of remoteOrgs" [value]="entry.id">{{entry.name}}</sl-menu-item>
</sl-select>

<div class="mt-8 text-right">
    <sl-button (click)="close()" i18n>Cancel</sl-button>
    <sl-button [disabled]="awaitingPopup" (click)="connect()" class="ml-3" type="primary" i18n>Connect</sl-button>
</div>
